<template>
    <nav class="navbar navbar-expand-lg navbar-light pb-2 pt-0">
        <div class="container-fluid justify-content-between">
            <button class="navbar-toggler" type="button" @click="toggleSidebar" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                <ul class="navbar-nav">
                    <template v-for="item in dataNavbar" :key="item.id">
                        <!-- Agar elementning bolalari bo'lmasa -->
                        <li v-if="item.children.length === 0" class="nav-item d-flex align-items-center">
                            <!-- Agar URL bo‘lsa, link orqali o‘tadi -->
                            <a v-if="item.url"
                               class="nav-link justify-content-center w-100"
                               :href="item.url"
                               target="_blank"
                               style="cursor: pointer;"
                               :class="{ 'active bg-secondary text-light rounded': isActive(item.id) }">
                                {{ item.name }}
                            </a>
                            <!-- Agar URL bo‘lmasa, menyu ichidagi sahifani chaqiradi -->
                            <div v-else
                                 class="nav-link justify-content-center w-100"
                                 @click="changeMenu(item.id, false)"
                                 style="cursor: pointer;"
                                 :class="{ 'active bg-secondary text-light rounded': isActive(item.id) }">
                                {{ item.name }}
                            </div>
                        </li>
                        <!-- Agar elementning bolalari bo'lsa (Drop-down menyu) -->
                        <li v-else class="nav-item dropdown d-flex align-items-center">
                            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                               aria-expanded="false"
                               :class="{ 'active bg-secondary text-light rounded': isActive(item.id) }">
                                {{ item.name }}
                            </a>
                            <ul class="dropdown-menu">
                                <template v-for="child in item.children" :key="child.id">
                                    <li v-if="child.children.length === 0">
                                        <div class="dropdown-item"
                                             @click="changeMenu(child.id, false)"
                                             style="cursor: pointer;"
                                             :class="{ 'active bg-secondary text-light rounded': isActive(child.id) }">
                                            {{ child.name }}
                                        </div>
                                    </li>
                                    <li v-else class="dropdown-item dropdown p-0">
                                        <a class="dropdown-item dropdown-toggle" href="#" role="button"
                                           data-bs-toggle="dropdown"
                                           :class="{ 'active bg-secondary text-light rounded': isActive(child.id) }">
                                            {{ child.name }}
                                        </a>
                                        <ul class="dropdown-menu dropdown-submenu">
                                            <li v-for="subChild in child.children" :key="subChild.id">
                                                <div class="dropdown-item" @click="changeMenu(subChild.id, false)"
                                                     style="cursor: pointer;"
                                                     :class="{ 'active bg-secondary text-light rounded': isActive(subChild.id) }">
                                                    {{ subChild.name }}
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                </template>
                            </ul>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </nav>
    <!-- Sidebar (mobil uchun) -->
    <transition name="slide">
        <div
            v-if="isSidebarOpen"
            class="offcanvas-backdrop fade show"
            @click="isSidebarOpen = false"
        ></div>
    </transition>
    <transition name="slide">
        <div
            v-if="isSidebarOpen"
            class="offcanvas offcanvas-start show"
            tabindex="-1"
            style="visibility: visible; width: 350px;"
            @click.stop
        >
            <div class="offcanvas-header">
                <h5 class="offcanvas-title">Menu</h5>
                <button
                    type="button"
                    class="btn-close"
                    @click="isSidebarOpen = false"
                ></button>
            </div>
            <div class="offcanvas-body">
                <ul class="navbar-nav">
                    <template v-for="item in dataNavbar" :key="item.id">
                        <!-- Agar elementning bolalari bo'lmasa -->
                        <li v-if="item.children.length === 0" class="nav-item">
                            <a
                                v-if="item.url"
                                class="nav-link text-dark"
                                :href="item.url"
                                target="_blank"
                                @click="changeMenu(item.id, true)"
                                :class="{ 'active bg-secondary text-light rounded': isActive(item.id) }"
                            >
                                {{ item.name }}
                            </a>
                            <div
                                v-else
                                class="nav-link text-dark"
                                @click="changeMenu(item.id, true)"
                                :class="{ 'active bg-secondary text-light rounded': isActive(item.id) }"
                            >
                                {{ item.name }}
                            </div>
                        </li>
                        <!-- Agar elementning bolalari bo'lsa (Dropdown) -->
                        <li v-else class="nav-item dropdown">
                            <a
                                class="nav-link dropdown-toggle text-dark"
                                href="#"
                                role="button"
                                data-bs-toggle="collapse"
                                :data-bs-target="'#collapse-' + item.id"
                                aria-expanded="false"
                                :aria-controls="'collapse-' + item.id"
                            >
                                {{ item.name }}
                            </a>
                            <ul
                                class="collapse list-unstyled ps-3"
                                :id="'collapse-' + item.id"
                            >
                                <template v-for="child in item.children" :key="child.id">
                                    <li v-if="child.children.length === 0">
                                        <div
                                            class="nav-link dropdown-item text-dark"
                                            @click="changeMenu(child.id, true)"
                                            :class="{ 'active bg-secondary text-light rounded': isActive(child.id) }"
                                        >
                                            {{ child.name }}
                                        </div>
                                    </li>
                                    <li v-else class="dropdown">
                                        <a
                                            class="nav-link dropdown-toggle dropdown-item text-dark"
                                            href="#"
                                            role="button"
                                            data-bs-toggle="collapse"
                                            :data-bs-target="'#subcollapse-' + child.id"
                                            aria-expanded="false"
                                            :aria-controls="'subcollapse-' + child.id"
                                        >
                                            {{ child.name }}
                                        </a>
                                        <ul
                                            class="collapse list-unstyled ps-4"
                                            :id="'subcollapse-' + child.id"
                                        >
                                            <li v-for="subChild in child.children" :key="subChild.id">
                                                <div
                                                    class="nav-link dropdown-item text-dark"
                                                    @click="changeMenu(subChild.id, true)"
                                                    :class="{ 'active bg-secondary text-light rounded': isActive(subChild.id) }"
                                                >
                                                    {{ subChild.name }}
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                </template>
                            </ul>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>
import { useRouter } from 'vue-router';
import api from '@/api';
import { buildUrlPath } from '@/utils';

export default {
    name: 'MainNavbar',
    setup() {
        const router = useRouter();
        return { router };
    },
    data() {
        return {
            loading: true,
            dataNavbar: [],
            language: localStorage.getItem('language') || 'uz',
            navbarId: parseInt(localStorage.getItem('navbar_item')) || 1,
            isSidebarOpen: false,
        };
    },
    methods: {
        async fetchNavbar() {
            this.loading = true;
            try {
                const { data } = await api.get(`/nav-item/`, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataNavbar = data;
            } catch (error) {
                console.error('Navbar ma\'lumotlari olinmadi:', error);
            } finally {
                this.loading = false;
            }
        },
        findItemById(items, id) {
            for (const item of items) {
                if (item.id === id) {
                    return item;
                }
                if (item.children && item.children.length > 0) {
                    const found = this.findItemById(item.children, id);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        },
        changeMenu(newNavbarId, fromSidebar = false) {
            this.navbarId = newNavbarId;
            const selectedItem = this.findItemById(this.dataNavbar, newNavbarId);
            const type = selectedItem && selectedItem.type ? selectedItem.type : 'null';

            localStorage.setItem('navbar_item', newNavbarId);
            localStorage.setItem('navbar-type', type);
            localStorage.setItem('currentPage', '1');

            const path = buildUrlPath(this.dataNavbar, newNavbarId);

            this.router.push(path);

            this.$emit('menuChanged', { navbarId: this.navbarId, type });

            if (fromSidebar) {
                this.isSidebarOpen = false;
                const navbarCollapse = document.getElementById('navbarNav');
                if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                    navbarCollapse.classList.remove('show');
                }
            }
        },
        isActive(id) {
            let current = this.navbarId;
            while (current) {
                if (current === id) {
                    return true;
                }
                current = this.getParentId(current);
            }
            return false;
        },
        getParentId(id) {
            const findParent = (items) => {
                for (let item of items) {
                    if (item.id === id) return item.parent_item;
                    if (item.children.length > 0) {
                        const parent = findParent(item.children);
                        if (parent) return parent;
                    }
                }
            };
            return findParent(this.dataNavbar);
        },
        toggleSidebar() {
            this.isSidebarOpen = !this.isSidebarOpen;
            if (this.isSidebarOpen) {
                const navbarCollapse = document.getElementById('navbarNav');
                if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                    navbarCollapse.classList.remove('show');
                }
            }
        },
    },
    mounted() {
        this.fetchNavbar();
    },
};
</script>

<style scoped>
.dropdown-menu {
    display: block;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.3s ease;
    min-width: 10rem;
    position: absolute;
    top: 100%;
    left: 0;
}

.nav-item.dropdown:hover > .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown-menu li {
    position: relative;
}

.dropdown-menu .dropdown-submenu {
    display: block;
    position: absolute;
    top: 0;
    left: 100%;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.3s ease;
    min-width: 10rem;
}

.dropdown-menu .dropdown-submenu-left {
    right: 100%;
    left: auto;
}

.dropdown-menu > li:hover > .dropdown-submenu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.nav-item {
    margin: 0 2rem;
}

.dropdown-item:focus,
.dropdown-item:active {
    background-color: inherit !important;
    color: inherit !important;
    box-shadow: none !important;
}

.nav-link.active {
    background-color: #6c757d !important;
    border-radius: 5px;
}

.nav-item:hover .nav-link:not(.active) {
    background-color: #e9ecef;
    border-radius: 5px;
}

.dropdown-item.active {
    background-color: #6c757d !important;
    border-radius: 5px;
}

.dropdown-item:hover:not(.active) {
    background-color: #e9ecef;
    border-radius: 5px;
}

/* Sidebar styles */
.offcanvas {
    transition: transform 0.3s ease-in-out;
}

.offcanvas.show {
    transform: translateX(0);
}

.offcanvas-backdrop {
    transition: opacity 0.3s ease-in-out;
}

.offcanvas .nav-link,
.offcanvas .dropdown-item {
    padding: 0.5rem 1rem;
    border-radius: 5px;
    margin: 0.2rem 0;
}

.offcanvas .collapse {
    transition: height 0.3s ease;
}

@media (max-width: 991.98px) {
    .nav-item:hover .nav-link:not(.active) {
        background-color: transparent !important;
    }
    .nav-item.dropdown:hover > .dropdown-menu {
        opacity: 0;
        visibility: hidden;
        transform: translateY(10px);
    }

    .navbar-nav {
        padding: 0.5rem;
    }

    .offcanvas .navbar-nav {
        padding: 0;
    }

    .offcanvas .dropdown-toggle::after {
        margin-left: 0.5rem;
    }

    .navbar-collapse {
        display: none !important;
    }

    .navbar-collapse.show {
        display: none !important;
    }
}
</style>
